<div
  class="subview white-bg nordic-blue-900-text transition-appear"
  *ngIf="subViewVisibleDelayed$ | async"
  [class.is-vishidden]="(subViewVisibleDelayed$ | async) === false"
  [class.transition-appear--active]="subViewVisible$ | finDelay | async"
  [attr.aria-labelledby]="labelledBy"
  (keyup.esc)="shouldCloseSubview.emit()"
  role="dialog"
>
  <div class="grow flex flex--column">
    <header class="modal-header flex--nogrow fill relative">
      <ng-content select="header" />
    </header>

    <div class="subview-content-wrapper flex-1 grow" [class.scroll]="enableScroll">
      <ng-container
        *ngIf="
          (ancillaryLoader$ | async) !== null && (ancillaryLoader$ | async) !== AncillaryLoaderStatus.OFF;
          else mainContent
        "
      >
        <fcom-loader [title]="'ancillaries.seats.reassigningYourSeats'" />
      </ng-container>

      <ng-template #mainContent>
        <ng-content select="main-content" />
      </ng-template>
    </div>
  </div>

  <ng-content select="global-content" />
</div>
